import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import {
  FaBars,
  FaHome,
  FaUsers,
  FaClipboardList,
  FaPlusCircle,
  FaGlobe,
  FaCalendarAlt,
  FaCarAlt,
  FaBriefcase,
  FaWrench,
  FaSignOutAlt
} from "react-icons/fa";
import Select from "react-select"; 
import { useTranslation } from "react-i18next";
import { useSidebar } from "../../SidebarContext";
import "./sidebar.css";
import Cookies from "js-cookie";
const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation(); 
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);
  const { isCollapsed, toggleSidebar } = useSidebar();

  const isActive = (path) => location.pathname === path;
  const languageOptions = [
    { value: "en", label: "English" },
    { value: "es", label: "Español" },
    { value: "ru", label: "Русский" },
    { value: "uk", label: "Українська" },
 
  ];

  const handleLanguageChange = (selectedOption) => {
    i18n.changeLanguage(selectedOption.value);
    document.cookie = `i18next=${selectedOption.value}; path=/`;
    setCurrentLanguage(selectedOption.value);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("authToken");
    Cookies.remove("access_token"); 
    
    navigate("/login");
  };

  return (
    <ProSidebar collapsed={isCollapsed}>
      <Menu iconShape="circle">
        <MenuItem icon={<FaBars />} onClick={toggleSidebar} className="toggle-button"></MenuItem>

        <MenuItem icon={<FaHome />} className={isActive("/") ? "active" : ""}>
          <Link to="/dashboard">{t("Dashboard")}</Link>
        </MenuItem>

        <MenuItem icon={<FaCalendarAlt />} className={isActive("/calendar") ? "active" : ""}>
          <Link to="/calendar">{t("Calendar")}</Link>
        </MenuItem>

        <MenuItem icon={<FaUsers />} className={isActive("/clients") ? "active" : ""}>
          <Link to="/clients">{t("Clients")}</Link>
        </MenuItem>

        <MenuItem icon={<FaCarAlt />} className={isActive("/cars") ? "active" : ""}>
          <Link to="/cars">{t("Cars")}</Link>
        </MenuItem>

        <MenuItem icon={<FaBriefcase />} className={isActive("/employees") ? "active" : ""}>
          <Link to="/employees">{t("Employees")}</Link>
        </MenuItem>

        <MenuItem icon={<FaClipboardList />} className={isActive("/workOrders") ? "active" : ""}>
          <Link to="/workOrders">{t("Work Orders")}</Link>
        </MenuItem>

        <SubMenu title={t("Services")} icon={<FaWrench />}>
          <MenuItem className={isActive("/services/complex") ? "active" : ""}>
            <Link to="/services/complex">{t("Complex Services")}</Link>
          </MenuItem>
          <MenuItem className={isActive("/services/regular") ? "active" : ""}>
            <Link to="/services/regular">{t("Regular Services")}</Link>
          </MenuItem>
        </SubMenu>

        <MenuItem icon={<FaPlusCircle />} className={isActive("/workOrders/add") ? "active" : ""}>
          <Link to="/workOrders/add">{t("Add Work Order")}</Link>
        </MenuItem>
      </Menu>

      <div className="sidebar-footer">
        <div className="language-picker">
          <FaGlobe className="language-icon" />
          {!isCollapsed && (
            <Select
              options={languageOptions}
              value={languageOptions.find((option) => option.value === currentLanguage)}
              onChange={handleLanguageChange}
              className="language-select"
              placeholder={t("Select Language")}
              menuPlacement="top"
            />
          )}
        </div>

        <button className="logout-button" onClick={handleLogout}>
          <FaSignOutAlt /> {!isCollapsed && <span>{t("Log Out")}</span>}
        </button>
      </div>
    </ProSidebar>
  );
};

export default Sidebar;
